module.exports = __webpack_public_path__ + "static/media/logos_squares_Platinum_MTR.654b49c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/home/partners_logos/logos_squares_Platinum_MTR.png
// module id = 91
// module chunks = 0